import { employeeContributionPairs, incomePair, isPairLocked } from '../contributionPairs';
import { useContributionFieldValues } from './useContributionFieldValues';

/**
 * True when the income source + percentage inputs should be disabled — i.e. the manual pair is the
 * active employee-side pair (an amount or frequency is entered and the income side is untouched),
 * so the income pair is locked. Engaging either half of the manual pair locks the employment side
 * ("one or the other"); the income pair wins ties (see [[contributionPairs]]).
 */
export const useManualContributionEntered = () =>
  isPairLocked(incomePair, employeeContributionPairs, useContributionFieldValues());
